export const DetailPopupRequestModel = {

  bankCode: '',
  tableNumber: '',
  relationRestrictedDataView: '',
  restrictedDataViewException: '',
  arrangementNumber: '',
  administrationCode: '',
  relationMarketSegmentCode: '',

};
